import { render, staticRenderFns } from "./TitleChip.vue?vue&type=template&id=210b4aa5&scoped=true&"
import script from "./TitleChip.ts?vue&type=script&lang=ts&"
export * from "./TitleChip.ts?vue&type=script&lang=ts&"
import style0 from "./TitleChip.scss?vue&type=style&index=0&id=210b4aa5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210b4aa5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
